<div
  [appCssStyler]="
    'general' | getViewConfigCssRulesPipe: configuration?.uiAttributes
  "
  [wrapperClass]="generalWrapperClass"
>
  <div
    class="notification-menu"
    [appCssStyler]="
      'miniCard' | getViewConfigCssRulesPipe: configuration?.uiAttributes
    "
    wrapperClass="face-miniCard-view"
  >
    <div
      class="notification-menu__header flex justify-between items-center p-4 border-bottom"
    >
      <strong class="flex">
        <span class="whitespace-nowrap overflow-hidden text-ellipsis">
          {{ counter?.name | propertyTranslator }}
        </span>

        <app-value-based-tooltip
          styleClass="mx-2"
          [value]="counter.description"
          position="end"
        />

        <span class="notification-menu__header__number text-sm px-2"
          >({{ entriesCount ?? 0 }})</span
        >
      </strong>
    </div>

    <ng-container
      [ngTemplateOutlet]="!entriesCount ? emptyList : notificationCounterMenu"
    ></ng-container>
  </div>
</div>
<ng-template #notificationCounterMenu>
  <app-mini-card-view
    [entries]="entries$ | async"
    [entity]="selectedEntity"
    [totalCount]="entriesCount"
    [loading]="entriesLoading$ | async"
    [miniCardConfig]="configuration?.entriesViewTypes.miniCard"
    (scrollEvent)="onScroll($event)"
    (clickEvent)="onClickItem($event)"
  ></app-mini-card-view>
</ng-template>

<ng-template #emptyList>
  <div
    class="flex justify-center items-center empty-list"
    data-testId="empty-msg"
  >
    {{ "COUNTERS.EMPTY" | translate }}!
  </div>
</ng-template>
